import { ResourceIdentifier } from "@megarax/client/src/resources/Resource";
import { AppModule } from "@/shared/app";
import { getResourceModule } from "./apps";

const baseRoute = "";

export function getResourceModulePath(
  identifier: ResourceIdentifier,
  id: number | string,
) {
  const module = getResourceModule(identifier.appLabel, identifier.name);
  if (!module) return null;

  return [baseRoute, module.app.route, module.route, id].join("/");
}

export function getModulePath(module: AppModule, action?: number | string) {
  const pathElements: (string | number)[] = [
    baseRoute,
    module.app.route,
    module.route,
  ];
  if (action) pathElements.push(action);
  return pathElements.join("/");
}
